module.exports = __webpack_public_path__ + "static/media/lamina13actividad.e228d041.png";